// @flow
import theme from "app/Theme/Theme";
import React from "react";
import { View, Text } from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import ArrowDownIcon from "./ArrowDownIcon";
import { MainText } from "./MainText";

type inputType = {
  value: string,
  placeholder: string,
  error: string,
};

const DateBox = ({ value, placeholder, error }: inputType) => {
  const { inputStyle, containerStyle } = styles;

  return (
    <View style={styles.mainContainerStyle}>
      <View style={containerStyle}>
        <Text
          style={value ? inputStyle : { ...inputStyle, color: "#A8A9B7" }}
          placeholder={placeholder}
          value={value}
        >
          {value || placeholder}
        </Text>
        <ArrowDownIcon />
      </View>

      {error ? (
        <MainText
          variant="l3-medium"
          marginTop={-"s"}
          marginLeft="sm"
          marginRight="sm"
          color="system.red.950"
        >
          {error}
        </MainText>
      ) : null}
    </View>
  );
};

const styles = {
  mainContainerStyle: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  inputStyle: {
    color: theme.colors["neutral.white"],
    paddingRight: 5,
    fontSize: 16,
    flex: 1,
    width: "100%",
    justifyContent: "center",
  },
  containerStyle: {
    color: "#A8A9B7",
    backgroundColor: "transparent",
    flexDirection: "row",
    width: wp("85%"),
    paddingRight: 25,
    paddingLeft: 25,
    height: 60,
    marginBottom: 12,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: "#A8A9B7",
    alignItems: "center",
    justifyContent: "space-between",
  },
};
export { DateBox };
